import signedOutModalEn from "./locales/en.json";

export const SIGNED_OUT_MODAL_NS = "signedOutModal" as const;

export const SignedOutModalI18n = {
  en: {
    [SIGNED_OUT_MODAL_NS]: {
      ...signedOutModalEn,
    },
  },
};
